<div class="carousel" v-on:keyup.left="previous" v-on:keyup.right="next" tabindex="-1">
    <div class="carousel__controls carousel__controls--left">
        <div class="carousel__controls-button left fa fa-angle-left" v-if="!isFirst" v-on:click="navigateTo('previous')"></div>
    </div>
    <div class="carousel__controls carousel__controls--right">
        <div class="carousel__controls-button right fa fa-angle-right" v-if="!isLast" v-on:click="navigateTo('next')"></div>
    </div>

    <div class="carousel__list" v-if="performer.id">
        <div class="carousel__list--slide" v-for="(photo, index) in photos" :key="photo.id" v-on:touchstart="onTouchStart" v-on:touchend="onTouchEnd" :class="{ 'current': index === currentImage, 'next': index === currentImage + 1, 'previous': index === currentImage - 1 }">
            <div class="carousel__list-picture" v-on:click="navigateTo('select', index)">
                <img :src="getSliderImages(performer, photo, '')" />
            </div>
        </div>
    </div>

    <div class="carousel__advert">
        <span>{{ performer.advertId }}</span>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/components/pages/carousel/carousel.tpl.html